"use strict";
// Reusable cross-component style snippets.
// Receives `palette` from createPalette() so color-based mixins stay synchronized.
Object.defineProperty(exports, "__esModule", { value: true });
const themeUtils_1 = require("themes/themeUtils");
function createMixins(palette) {
    return {
        toolBar: {
            height: 70,
            paddingLeft: 32,
            paddingRight: 32,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
        },
        register: {
            // -- spacing --
            paddingLeft: 20,
            paddingRight: 20,
            rowInnerPadding: 6,
            fieldPadding: 1,
            // projectedSmallOffset: 116,
            // projectedBigOffset: 396,
            // -- typography --
            fontSize: {
                small: '12px',
                default: '14px',
                large: '16px',
            },
            // -- sizing --
            projectedHeightClosed: 52,
            projectedHeightOpen: 332,
            splitRowHeight: 45,
            checkboxSize: 20,
            controlBarHeight: 60,
            sectionHeaderHeight: 34,
            noUnderline: true,
            // -- colors --
            fieldBorderColor: palette.link.interactive,
            splitsBackground: palette.surface.regTableRow,
            headerBackground: palette.background.subtle,
            headerBorder: (0, themeUtils_1.applyOpacityToHex)(palette.border.dark, 0.5),
            editRowColor: palette.background.subtle,
            // catTagDropdown: palette.backdrop.registerDropdown,
            sectionHeaderColor: (0, themeUtils_1.applyOpacityToHex)(palette.background.elevated, 0.3),
            sectionHeaderBorder: (0, themeUtils_1.applyOpacityToHex)(palette.border.dark, 0.3),
            rowHoverColor: palette.background.subtle,
            fieldHoverColor: palette.backdrop.fieldHover,
            transferDelimeter1: '[',
            transferDelimeter2: ']',
            fieldMargin: 8,
            pendingTextColor: palette.link.interactive,
        },
        accountDrawer: {
            // -- sizing --
            width: 306,
            accountListLevelIndent: 4,
            accountListBaseFontSize: 14.5,
            drawerListTitleFontSize: '17px',
            titleTransform: 'uppercase',
            titleWeight: 500,
            basePadding: 16,
            listPaddingLeft: 16,
            listPaddingRight: 28,
            iconSize: 20,
            collapsePoint: 1150,
            collapsedWidth: 16,
            // -- text colors --
            positiveBalance: null,
            highlightText: palette.text.primary,
            textColor: palette.text.primary,
            headerListText: palette.text.primary,
            l2TextColor: (0, themeUtils_1.applyOpacityToHex)(palette.text.primary, 0.93),
            l3TextColor: (0, themeUtils_1.applyOpacityToHex)(palette.text.primary, 0.88),
            negativeBalance: palette.amount.negative,
            // -- background colors --
            background: palette.background.elevated,
            highlightColor: palette.action.selectedDark,
            hoverColor: palette.action.hoverLight,
            l1Color: null,
            headerBackground: palette.background.elevated,
            // -- animation --
            accountDrawerAnimation: 'all 500ms cubic-bezier(0.550, 0.085, 0.680, 0.530)',
            // -- other colors --
            borderColor: palette.border.brand,
            divider: palette.text.tertiary,
            openControl: palette.background.paper,
            icon: palette.text.tertiary,
            errorIcon: palette.amount.negative,
            refreshIcon: palette.text.primary,
            actionColor: palette.text.primary,
            actionButtonSize: 40,
            // -- row sizing --
            l1Margin: 0,
            l0Height: 37,
            l1Height: 52,
            l2Height: 34,
            l3Height: 32,
            addFiLabel: null,
        },
        navigation: {
            // -- sizing --
            barWidth: 56,
            iconSize: 24,
            iconVerticalSpacing: 16,
            selectedIconAnimation: 'all 200ms cubic-bezier(0.550, 0.085, 0.680, 0.530)',
            barWidthOpen: 246,
            rowOpacity: 1,
            // -- colors --
            headerColor: palette.background.dark,
            selectedBackground: palette.backdrop.navSelected,
            hoverBackground: palette.backdrop.navHover,
            iconColor: palette.icon.nav,
            selectedIconColor: palette.icon.nav,
            iconHoverColor: palette.icon.nav,
            textColor: palette.text.onNav,
            selectedTextColor: palette.text.onNav,
        },
        appBar: {
            color: palette.text.primary,
            borderRadius: 0,
            opacity: 1,
            borderBottom: `1px solid ${palette.border.default}`,
            boxShadow: 'none',
            background: palette.background.paper,
            zIndex: 1,
            height: 70,
            position: 'sticky',
            display: 'flex',
        },
    };
}
exports.default = createMixins;
